var storefrontApp = angular.module("storefrontApp");

storefrontApp.controller("aiSearchController", [
    "$scope",
    "$http",
    "$timeout",
    "$q",
    function ($scope, $http, $timeout, $q) {
        var fallbackIdeas = [
            "Woodland animals for baby blankets",
            "Dog breeds collection for gifts",
            "Farm animals with applique finish",
            "Sports mascots for varsity jackets",
            "Minimal line art botanicals"
        ];

        $scope.searchQuery = "";
        $scope.products = []; // Used for empty state checks
        $scope.emptyRecommendations = angular.copy(fallbackIdeas);
        $scope.fallbackIdeas = angular.copy(fallbackIdeas);
        $scope.isLoading = false;
        $scope.errorMessage = "";
        $scope.showListings = false; // Flag to show listings section

        $scope.submitSearch = function () {
            var query = ($scope.searchQuery || "").trim();
            if (!query) {
                return;
            }

            $scope.isLoading = true;
            $scope.errorMessage = "";

            fetchAiSearchItemIds()
                .then(function (payload) {
                    // Set products array for empty state checks (listingsController handles actual display)
                    $scope.products = payload && payload.results && payload.results.products ? payload.results.products : [];

                    var suggestions = extractSuggestions(payload);

                    if (suggestions.length) {
                        $scope.emptyRecommendations = suggestions.slice(0, 10);
                    } else if (!$scope.products.length) {
                        $scope.emptyRecommendations = angular.copy(fallbackIdeas);
                    }
                })
                .catch(function (error) {
                    $scope.errorMessage = "Something went wrong. Please try again.";
                    $scope.products = [];
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };

        $scope.onSearchKeyPress = function (event) {
            // Submit search when Enter key is pressed
            if (event.keyCode === 13 || event.which === 13) {
                event.preventDefault();
                $scope.submitSearch();
            }
        };

        $scope.resetSearch = function () {
            $scope.searchQuery = "";
            $scope.products = [];
            $scope.errorMessage = "";
            $scope.emptyRecommendations = angular.copy(fallbackIdeas);
            $scope.showListings = false;
            
            // Clear AI search filters
            if (window.listingFilters) {
                window.listingFilters['isAiSearch'] = "false";
                window.listingFilters['aiSearchQuery'] = "";
                window.listingFilters['aiSearchResults'] = "";
            }
        };

        $scope.useFallbackIdea = function (idea) {
            if (!idea) {
                return;
            }
            $scope.searchQuery = idea;
            $scope.submitSearch();
        };

        function extractSuggestions(payload) {
            if (!payload) {
                return [];
            }
            var candidates = [];
            if (payload.searchRequest && angular.isArray(payload.searchRequest.category)) {
                candidates = candidates.concat(payload.searchRequest.category);
            }
            if (angular.isArray(payload.suggestions)) {
                candidates = payload.suggestions;
            } else if (angular.isArray(payload.fallbackSuggestions)) {
                candidates = payload.fallbackSuggestions;
            }
            return candidates;
        }

        function fetchAiSearchItemIds() {
            // Get values from store settings, with fallback defaults
            var aiKnnValues = (window.__env && window.__env.aiKnnValues) || {
                topK: 800,
                numCandidates: 1000,
                themeWeight: 0.7,
                specWeight: 0.3
            };
            
            // Make POST request to get item IDs from AI search endpoint
            return $http({
                method: 'POST',
                url: '/analyzesearch',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: 'Query=' + encodeURIComponent($scope.searchQuery) + 
                      '&TopK=' + aiKnnValues.topK + 
                      '&NumCandidates=' + aiKnnValues.numCandidates + 
                      '&ThemeWeight=' + aiKnnValues.themeWeight + 
                      '&SpecWeight=' + aiKnnValues.specWeight,
                transformRequest: function(data) {
                    return data; // Already formatted as form data
                }
            }).then(function(response) {
                // Initialize window.listingFilters if it doesn't exist
                if (!window.listingFilters) {
                    window.listingFilters = [];
                }
                
                var responseData = response.data || {};
                var extractedParams = responseData.extractedParams || null;
                
                // SCENARIO 1: Check if AI search was successful (has itemIds)
                var isSuccess = responseData.success === true && 
                               responseData.itemIds && 
                               angular.isArray(responseData.itemIds) && 
                               responseData.itemIds.length > 0;
                
                // SCENARIO 2: Check if we have extractedParams for fallback search
                var hasExtractedParams = extractedParams !== null && 
                                       typeof extractedParams === 'object' &&
                                       (extractedParams.originalQuery || 
                                        (extractedParams.tags && extractedParams.tags.length > 0) ||
                                        (extractedParams.category && extractedParams.category.length > 0));
                
                // Extract and normalize item IDs (for Scenario 1)
                var itemIds = [];
                if (isSuccess) {
                    itemIds = responseData.itemIds
                        .map(function(id) {
                            return String(id).toLowerCase();
                        })
                        .filter(function(id) {
                            return id && id.length > 0;
                        });
                }
                
                // Helper function to scroll to results section
                var scrollToResults = function() {
                    var resultsSection = document.getElementById('ai-search-results');
                    if (resultsSection) {
                        var headerOffset = 80; // Offset for fixed header if any
                        var elementPosition = resultsSection.getBoundingClientRect().top;
                        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                        
                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });
                    }
                };
                
                // Helper function to trigger listingsController reload
                var triggerListingsReload = function() {
                    var listingsElement = document.querySelector('[ng-controller="listingsController"]');
                    if (listingsElement) {
                        var listingsScope = angular.element(listingsElement).scope();
                        if (listingsScope) {
                            // Check if listingsController is already initialized
                            // ippOptions is set in initialize(), so if it exists, controller is initialized
                            var isInitialized = listingsScope.ippOptions && listingsScope.ippOptions.length > 0;
                            
                            if (!isInitialized) {
                                // First time - initialize listingsController (this will call getListingsData internally)
                                if (listingsScope.initialize) {
                                    if (listingsScope.$root.$$phase !== '$apply' && listingsScope.$root.$$phase !== '$digest') {
                                        listingsScope.$apply(function() {
                                            listingsScope.initialize();
                                        });
                                    } else {
                                        listingsScope.initialize();
                                    }
                                }
                            } else {
                                // Already initialized - clear all filter arrays first, then update filters and reload data
                                // Clear all filter arrays to prevent old filters from persisting
                                if (listingsScope.$root.$$phase !== '$apply' && listingsScope.$root.$$phase !== '$digest') {
                                    listingsScope.$apply(function() {
                                        // Clear all filter arrays
                                        listingsScope.selectedCategories = [];
                                        listingsScope.selectedSubCategories = [];
                                        listingsScope.selectedBrands = [];
                                        listingsScope.selectedCatalog = [];
                                        listingsScope.selectedPrdDefs = [];
                                        listingsScope.selectedOtherFilters = [];
                                        listingsScope.selectedAvailabilityFilters = [];
                                        listingsScope.fontType = [];
                                        listingsScope.selectedThemes = [];
                                        listingsScope.selectedColors = [];
                                        listingsScope.selectedPatterns = [];
                                        listingsScope.selectedMaterials = [];
                                        listingsScope.selectedLicensedSports = [];
                                        listingsScope.selectedConditions = [];
                                        listingsScope.selectedMachineHS = [];
                                        listingsScope.selectedMachineTypes = [];
                                        listingsScope.selectedAuthorFilters = [];
                                        listingsScope.selectedCategoryFilters = [];
                                        listingsScope.selectedTypeFilters = [];
                                        listingsScope.selectedPatchFilters = [];
                                        
                                        // Re-read filters from window.listingFilters
                                        if (listingsScope.getFiltersOnLoad) {
                                            listingsScope.getFiltersOnLoad();
                                        }
                                        
                                        // Reset pagination to page 1 for new search
                                        if (listingsScope.pg !== undefined) {
                                            listingsScope.pg = "1";
                                        }
                                        
                                        // Trigger data reload
                                        if (listingsScope.getListingsData) {
                                            listingsScope.getListingsData();
                                        }
                                    });
                                } else {
                                    // Clear all filter arrays
                                    listingsScope.selectedCategories = [];
                                    listingsScope.selectedSubCategories = [];
                                    listingsScope.selectedBrands = [];
                                    listingsScope.selectedCatalog = [];
                                    listingsScope.selectedPrdDefs = [];
                                    listingsScope.selectedOtherFilters = [];
                                    listingsScope.selectedAvailabilityFilters = [];
                                    listingsScope.fontType = [];
                                    listingsScope.selectedThemes = [];
                                    listingsScope.selectedColors = [];
                                    listingsScope.selectedPatterns = [];
                                    listingsScope.selectedMaterials = [];
                                    listingsScope.selectedLicensedSports = [];
                                    listingsScope.selectedConditions = [];
                                    listingsScope.selectedMachineHS = [];
                                    listingsScope.selectedMachineTypes = [];
                                    listingsScope.selectedAuthorFilters = [];
                                    listingsScope.selectedCategoryFilters = [];
                                    listingsScope.selectedTypeFilters = [];
                                    listingsScope.selectedPatchFilters = [];
                                    
                                    // Re-read filters from window.listingFilters
                                    if (listingsScope.getFiltersOnLoad) {
                                        listingsScope.getFiltersOnLoad();
                                    }
                                    
                                    // Reset pagination to page 1 for new search
                                    if (listingsScope.pg !== undefined) {
                                        listingsScope.pg = "1";
                                    }
                                    
                                    // Trigger data reload
                                    if (listingsScope.getListingsData) {
                                        listingsScope.getListingsData();
                                    }
                                }
                            }
                            
                            // Scroll to results after data is loaded and rendered
                            $timeout(function() {
                                scrollToResults();
                            }, 300);
                        }
                    } else {
                        // If listingsController element doesn't exist yet, wait a bit more
                        $timeout(triggerListingsReload, 100);
                    }
                };
                
                // Helper function to set default filter values
                var setDefaultFilters = function() {
                    if (!window.listingFilters['brands']) window.listingFilters['brands'] = "";
                    if (!window.listingFilters['catalog']) window.listingFilters['catalog'] = "";
                    if (!window.listingFilters['saleName']) window.listingFilters['saleName'] = "";
                    if (!window.listingFilters['sortBy']) window.listingFilters['sortBy'] = "";
                    if (!window.listingFilters['licensed']) window.listingFilters['licensed'] = "";
                    if (!window.listingFilters['categories']) window.listingFilters['categories'] = "";
                    if (!window.listingFilters['onSale']) window.listingFilters['onSale'] = "";
                    if (!window.listingFilters['newProducts']) window.listingFilters['newProducts'] = "";
                    if (!window.listingFilters['freeProducts']) window.listingFilters['freeProducts'] = "";
                    if (!window.listingFilters['parentCategory']) window.listingFilters['parentCategory'] = "";
                    if (!window.listingFilters['pgView']) window.listingFilters['pgView'] = "grid";
                    if (!window.listingFilters['isPdfAvailable']) window.listingFilters['isPdfAvailable'] = "";
                    if (!window.listingFilters['fontType']) window.listingFilters['fontType'] = "";
                    if (!window.listingFilters['isDesignUsedInProject']) window.listingFilters['isDesignUsedInProject'] = "";
                    if (!window.listingFilters['inStock']) window.listingFilters['inStock'] = "";
                    if (!window.listingFilters['themes']) window.listingFilters['themes'] = "";
                    if (!window.listingFilters['colors']) window.listingFilters['colors'] = "";
                    if (!window.listingFilters['patterns']) window.listingFilters['patterns'] = "";
                    if (!window.listingFilters['materials']) window.listingFilters['materials'] = "";
                    if (!window.listingFilters['licensedSports']) window.listingFilters['licensedSports'] = "";
                    if (!window.listingFilters['conditions']) window.listingFilters['conditions'] = "";
                    if (!window.listingFilters['hoops']) window.listingFilters['hoops'] = "";
                    if (!window.listingFilters['machineTypes']) window.listingFilters['machineTypes'] = "";
                    if (!window.listingFilters['ProductIdForMatch']) window.listingFilters['ProductIdForMatch'] = "";
                    if (!window.listingFilters['memberOnly']) window.listingFilters['memberOnly'] = "";
                    if (!window.listingFilters['customType']) window.listingFilters['customType'] = "";
                };
                
                // SCENARIO 1: AI Search Success - Use itemIds for Elasticsearch
                if (isSuccess && itemIds.length > 0) {
                    // Set up AI search filters
                    window.listingFilters['isAiSearch'] = "true";
                    window.listingFilters['aiSearchQuery'] = encodeURIComponent($scope.searchQuery);
                    window.listingFilters['aiSearchResults'] = itemIds.join(',');
                    window.listingFilters['searchTerm'] = ""; // Clear regular search term for AI search
                    
                    // Set prdDefinitions from extractedParams if available, otherwise empty
                    if (extractedParams && extractedParams.productDefinition) {
                        window.listingFilters['prdDefinitions'] = extractedParams.productDefinition;
                    } else {
                        window.listingFilters['prdDefinitions'] = "";
                    }
                    
                    setDefaultFilters();
                    
                    // Show listings section - listingsController will handle the Elasticsearch call
                    $scope.showListings = true;
                    
                    // Scroll to results section after it appears
                    $timeout(function() {
                        scrollToResults();
                    }, 300);
                    
                    // Trigger listingsController to reload with AI search filters
                    $timeout(triggerListingsReload, 0);
                    
                    // Return empty payload - listingsController will fetch data with AI search itemIds
                    return $q.resolve({ results: { products: [] } });
                }
                
                // SCENARIO 2: No vectors but extractedParams available - Use extractedParams for search
                else if (hasExtractedParams) {
                    // Set up search using extractedParams
                    window.listingFilters['isAiSearch'] = "false";
                    window.listingFilters['aiSearchQuery'] = "";
                    window.listingFilters['aiSearchResults'] = "";
                    
                    // Set categories from extractedParams.category and tags if available
                    var categoryArray = [];
                    if (extractedParams.category && extractedParams.category.length > 0) {
                        categoryArray = categoryArray.concat(extractedParams.category);
                    }
                    if (extractedParams.tags && extractedParams.tags.length > 0) {
                        categoryArray = categoryArray.concat(extractedParams.tags);
                    }
                    
                    if (categoryArray.length > 0) {
                        // Use categories/tags for filtering
                        // Pick one random term from the array for searchTerm
                        var randomIndex = Math.floor(Math.random() * categoryArray.length);
                        window.listingFilters['searchTerm'] = categoryArray[randomIndex];
                    } else {
                        // No categories/tags available, use search term instead
                        window.listingFilters['searchTerm'] = extractedParams.originalQuery || $scope.searchQuery;
                    }
                    
                    // Set prdDefinitions from extractedParams.productDefinition or default to 'All'
                    if (extractedParams.productDefinition) {
                        window.listingFilters['prdDefinitions'] = extractedParams.productDefinition;
                    } else {
                        window.listingFilters['prdDefinitions'] = "All";
                    }
                    
                    setDefaultFilters();
                    
                    // Show listings section - listingsController will handle search with extractedParams
                    $scope.showListings = true;
                    
                    // Scroll to results section after it appears
                    $timeout(function() {
                        scrollToResults();
                    }, 300);
                    
                    // Trigger listingsController to reload with extractedParams search
                    $timeout(triggerListingsReload, 0);
                    
                    // Return empty payload - listingsController will fetch data with extractedParams
                    return $q.resolve({ results: { products: [] } });
                }
                
                // SCENARIO 3: Complete failure - Fallback to Regular Search
                else {
                    // Set up regular search filters
                    window.listingFilters['isAiSearch'] = "false";
                    window.listingFilters['aiSearchQuery'] = "";
                    window.listingFilters['aiSearchResults'] = "";
                    window.listingFilters['searchTerm'] = $scope.searchQuery; // Use user's search term for regular search
                    window.listingFilters['prdDefinitions'] = "All"; // Default to 'All'
                    window.listingFilters['categories'] = ""; // Clear categories
                    
                    setDefaultFilters();
                    
                    // Show listings section - listingsController will handle regular search
                    $scope.showListings = true;
                    
                    // Scroll to results section after it appears
                    $timeout(function() {
                        scrollToResults();
                    }, 300);
                    
                    // Trigger listingsController to reload with regular search
                    $timeout(triggerListingsReload, 0);
                    
                    // Return empty payload - listingsController will fetch data with regular search
                    return $q.resolve({ results: { products: [] } });
                }
            });
        }

        function getQueryParameter(name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
            var results = regex.exec(window.location.search);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        }

        (function init() {
            $scope.fallbackIdeas = angular.copy(fallbackIdeas);
            $scope.resetSearch();
            
            // Check for 'searchterm' query parameter and auto-trigger search
            var queryParam = getQueryParameter('searchterm');
            if (queryParam && queryParam.trim() !== "") {
                $scope.searchQuery = queryParam.trim();
                // Small delay to ensure page is fully loaded
                $timeout(function() {
                    $scope.submitSearch();
                }, 100);
            }
        })();
    }
]);
